module.exports = __webpack_public_path__ + "b2afaf2b30718b2e6a2501a74ee91d02.png";